import React, { useContext } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ThemeContext from '../contexts/ThemeContext';
import i18n from '../i18n';
import { isHeroBrandEnabled } from '../utils/heroBrandUtils';
import heroLogoHorizontalWhite from '../images/hero_logo_horizontal_white.png';
import Icon from './Icon';

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ colors, isHeroTolk }) =>
    isHeroTolk ? (colors?.buttonColor || colors?.containerColor || '#45446b') : '#45446b'};
  padding: 8px 16px;
  width: 100%;
  box-sizing: border-box;
  min-height: 45px;
`;

const CancelButtonContainer = styled.div`
  width: 124px;
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    width: auto;
  }
`;

const CancelButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px 16px 6px 8px;
  border-radius: 20px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:active {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

const ArrowIcon = styled.div`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

const CancelText = styled.span`
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 1.2;
  color: #ffffff;
  letter-spacing: 0.15px;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 41px;
  flex: 1;

  img {
    max-height: 100%;
    max-width: 152px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    max-width: 100px;
    height: 35px;
  }
`;

const Spacer = styled.div`
  width: 124px;

  @media (max-width: 768px) {
    width: auto;
  }
`;

const PrebookingHeader = ({ onCancel, closeMode }) => {
  const { colors } = useContext(ThemeContext);

  const isHeroTolk = isHeroBrandEnabled();
  const logoSrc = isHeroTolk
    ? heroLogoHorizontalWhite
    : (colors.headerLogo2020?.default || colors.headerLogo2020);

  const buttonLabel = closeMode ? i18n('close') : i18n('back');

  return (
    <HeaderContainer colors={colors} isHeroTolk={isHeroTolk}>
      <CancelButtonContainer>
        <CancelButton onClick={onCancel} title={buttonLabel}>
          <ArrowIcon>
            <Icon
              icon={closeMode ? 'close' : 'arrow_back'}
              iconLib="material"
              iconColor="white"
              iconSize={20}
              withoutContainer={true}
            />
          </ArrowIcon>
          <CancelText>{buttonLabel}</CancelText>
        </CancelButton>
      </CancelButtonContainer>

      <LogoContainer>
        {logoSrc && (
          <img
            src={logoSrc}
            alt="Logo"
          />
        )}
      </LogoContainer>

      <Spacer />
    </HeaderContainer>
  );
};

PrebookingHeader.propTypes = {
  onCancel: PropTypes.func.isRequired,
  closeMode: PropTypes.bool,
};

export default PrebookingHeader;
